import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import dashboard from './modules/dashboard'
import templates from './modules/templates'
import createTemplate from './modules/createTemplate'
import groupMessage from './modules/groupMessage'
import statement from './modules/statement'
import settings from './modules/settings'
import detection from './modules/detection'
import permission from './modules/permission'
import { getCookie } from '../utils/cookie'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    profile: {},
    remain: {},
    isPost: {},
    subscription: {},
    readOnly: !!getCookie('crmToken') || false
  },
  mutations,
  actions,
  modules: {
    dashboard,
    templates,
    createTemplate,
    groupMessage,
    statement,
    settings,
    detection,
    permission
  },
  getters,
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js